import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { residentialEnum, commercialEnum } from '../../static-criteria-arguments';
import { messages } from './messages';
import { RESIDENTIAL_OR_COMMERCIAL } from '../../../../filters/constants';

const getValue = (value) => (value ? residentialEnum : commercialEnum);
const isLegacy = (value) => typeof value === 'boolean';

const sanitizeSavedViewFilter = (filter) => {
  const { criterionArgumentValue } = filter;
  const filterIsLegacy = isLegacy(criterionArgumentValue);
  const updatedValue = filterIsLegacy ? getValue(criterionArgumentValue) : criterionArgumentValue;
  return {
    ...filter,
    type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
    criterionArgumentValue: updatedValue,
  };
};

export const ResidentialCommercial = {
  id: RESIDENTIAL_OR_COMMERCIAL,
  displayName: <FormattedMessage {...messages.residentialOrCommercial} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'isResidential',
  shouldHideActionButtons: true,
  expectsArgumentAsArray: true,
  allowsMultipleSelection: true,

  render: (criteriaInformations, existingFilterHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFilterHelpers);
  },

  sanitizeSavedViewFilter,
};
